export default "__VITE_ASSET__DLlk7T7a__"